export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "record.worker_bundle.f01ed5729c65667b625c.worker.js");
}
